import { render, staticRenderFns } from "./CtrlFormularioDinamicoPage.vue?vue&type=template&id=2c45088c"
import script from "./CtrlFormularioDinamicoPage.vue?vue&type=script&lang=js"
export * from "./CtrlFormularioDinamicoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports